import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ExpedientesService } from '../services/expedientes.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { UploadFilesComponent } from '../../components/modal/upload-files/upload-files.component';
import { EmailModalComponent } from '../modal/email-modal/email-modal.component';
import Swal from 'sweetalert2';
import { CheckSigafirmaComponent } from '../modal/check-sigafirma/check-sigafirma.component';
import { CancelarPedidoComponent } from '../modal/cancelar-pedido/cancelar-pedido.component';
import { PageService } from '../services/page.service';
import { SolicitudesFirmaModalComponent } from '../modal/solicitudes-firma-modal/solicitudes-firma-modal.component';
import { CancelarFirmaComponent } from '../modal/cancelar-firma/cancelar-firma.component';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import * as FileSaver from 'file-saver';
import { UpdateSolicitudModalComponent } from 'src/app/components/update-solicitud-modal/update-solicitud-modal.component';

@Component({
  selector: 'app-solicitudes',
  templateUrl: './solicitudes.component.html',
  styleUrls: ['./solicitudes.component.css'],
  animations: [
    trigger('detailExpand', [
      state(
        'void',
        style({ height: '0px', minHeight: '0', visibility: 'hidden' })
      ),
      state('*', style({ height: '*', visibility: 'visible' })),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class SolicitudesComponent implements OnInit, AfterViewInit {
  // Array de solicitudes
  solicitudes: any;

  // Def de las columnas de la tabla
  columns: string[] = [
    'numPedido',
    'expedienteAyudas',
    'tipo',
    'tipoTramite',
    'colaborador',
    'matricula',
    'bastidor',
    'generadoExpediente',
    'nif',
    'fecha',
    'actions',
  ];
  docList: any[] = [];
  // Filtrado
  public searchForm: FormGroup;

  spinner = true;

  public tipo = '';
  public colaborador = '';
  public matricula = '';
  public bastidor = '';
  public nif = '';
  public fecha = '';
  rol;
  disabled = false;
  colaboradores: any[];

  formData: FormData;

  filtro: any = {
    fecha: null,
    tipo: null,
    bastidor: null,
    matricula: null,
    nif: null,
  };
  // Paginator
  lenghtPagination: number;
  pageEvent: PageEvent;
  pageIndex: number;
  pageSize: number;
  role = '';
  activeTabIndex = 0;
  groupedSolicitudes: Array<{ key: string; label: string; icon: string; color: string; items: any[] }> = [];
  expandedCards: Set<number> = new Set();

  readonly kanbanColumns = [
    { key: 'PENDIENTE', label: 'Pendiente', icon: 'hourglass_empty', color: '#ff9800' },
    { key: 'PENDIENTE FORMULARIO CLIENTE', label: 'Pend. Formulario Cliente', icon: 'assignment_late', color: '#f44336' },
    { key: 'FORMULARIO COMPLETADO', label: 'Formulario Completado', icon: 'assignment_turned_in', color: '#2196f3' },
    { key: 'EXPEDIENTE GENERADO', label: 'Expediente Generado', icon: 'check_circle', color: '#4caf50' },
    { key: 'CANCELADA', label: 'Cancelada', icon: 'cancel', color: '#9e9e9e' },
  ];

  // Paginator y sorter para Mat-Tables
  @ViewChild('MatPaginator', { static: false, read: true })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  isExpansionDetailRow = (index, row) => row.hasOwnProperty('detailRow');

  constructor(
    private expService: ExpedientesService,
    private router: Router,
    private date: DatePipe,
    private dialog: MatDialog,
    private pageService: PageService,
    private cdRef: ChangeDetectorRef
  ) {
    this.rol = sessionStorage.getItem('rol');
    this.disabled = this.rol === 'VENTAS' || this.rol === 'CONSULTA';
    console.log(this.disabled);
  }

  async ngOnInit(): Promise<void> {
    this.searchFormInit();
    this.solicitudes = new MatTableDataSource();
    this.role = sessionStorage.getItem('rol') ?? '';
    switch (this.role) {
      case 'GRUPO':
        this.colaboradores = JSON.parse(
          sessionStorage.getItem('colaboradores')
        );
        break;
      default:
        if (sessionStorage.getItem('colaborador') === 'AUTOMOVILES PALMA SA') {
          this.colaboradores = ['AUTOMOVILES PALMA SA', 'MERCADONA SA'];
        } else {
          this.colaboradores = [sessionStorage.getItem('colaborador')];
        }
        break;
    }
    this.expService
      .getSolicitudes(this.colaboradores, this.filtro)
      .subscribe((res) => {
        this.solicitudes.data = res.items;
        this.updateGroupedSolicitudes();
        console.log(res);
        this.spinner = false;
        this.lenghtPagination = res.count;
        this.pageIndex = res.page - 1;
        this.pageSize = res.size;
        console.log('Solicitudes', this.solicitudes);
        this.cdRef.detectChanges();
      });
  }
  ngAfterViewInit(): void {
    this.solicitudes.paginator = this.paginator;
    this.solicitudes.sort = this.sort;
    this.cdRef.detectChanges();
  }

  searchFormInit(): void {
    this.searchForm = new FormGroup({
      tipo: new FormControl('', Validators.pattern('^[a-zA-Z ]+$')),
      colaborador: new FormControl('', Validators.pattern('^[a-zA-Z ]+$')),
      matricula: new FormControl('', Validators.pattern('^[a-zA-Z ]+$')),
      numPedido: new FormControl('', Validators.pattern('^[a-zA-Z ]+$')),
      expedienteAyudas: new FormControl('', Validators.pattern('^[a-zA-Z ]+$')),
      bastidor: new FormControl('', Validators.pattern('^[a-zA-Z ]+$')),
      nif: new FormControl('', Validators.pattern('^[a-zA-Z ]+$')),
      fecha: new FormControl(),
    });
  }

  applyFilter(): void {
    this.solicitudes.data = [];
    this.updateGroupedSolicitudes();
    console.log(this.searchForm.value);
    const numP =
      this.searchForm.get('numPedido').value === null
        ? null
        : this.searchForm.get('numPedido').value.length <= 2
        ? null
        : this.searchForm.get('numPedido').value;
    const expA =
      this.searchForm.get('expedienteAyudas').value === null
        ? null
        : this.searchForm.get('expedienteAyudas').value.length <= 2
        ? null
        : this.searchForm.get('expedienteAyudas').value;
    const mat =
      this.searchForm.get('matricula').value === null
        ? null
        : this.searchForm.get('matricula').value.length <= 2
        ? null
        : this.searchForm.get('matricula').value;
    const nifi =
      this.searchForm.get('nif').value === null
        ? null
        : this.searchForm.get('nif').value.length <= 2
        ? null
        : this.searchForm.get('nif').value;
    const bas =
      this.searchForm.get('bastidor').value === null
        ? null
        : this.searchForm.get('bastidor').value.length <= 4
        ? null
        : this.searchForm.get('bastidor').value;
    const tra =
      this.searchForm.get('tipo').value === null
        ? null
        : this.searchForm.get('tipo').value.toUpperCase();
    const fech = this.date.transform(
      this.searchForm.get('fecha').value,
      'dd-MM-yyyy'
    );

    this.filtro = {
      fecha: fech,
      matricula: mat,
      tipo: tra,
      bastidor: bas,
      nif: nifi,
      numPedido: numP,
      expedienteAyudas: expA,
    };
    const col = this.searchForm.get('colaborador').value;
    if (col !== null && col !== '') {
      console.log('ENTRO');
      this.expService
        .getSolicitudes([this.searchForm.get('colaborador').value], this.filtro)
        .subscribe((res) => {
          this.solicitudes.data = res.items;
          this.updateGroupedSolicitudes();
          console.log(res);
          this.lenghtPagination = res.count;
          this.pageIndex = res.page - 1;
          this.pageSize = res.size;
          return event;
        });
    } else {
      console.log(this.colaboradores);
      this.expService
        .getSolicitudes(this.colaboradores, this.filtro)
        .subscribe((res) => {
          this.solicitudes.data = res.items;
          this.updateGroupedSolicitudes();
          console.log(res);
          this.lenghtPagination = res.count;
          this.pageIndex = res.page - 1;
          this.pageSize = res.size;
          return event;
        });
    }
  }

  reutilizar(row): void {
    sessionStorage.setItem('id', row.id);
    sessionStorage.setItem('colaborador', row.colaborador);
    if (row.tipo.toLowerCase().includes('matriculaci')) {
      this.router.navigate(['page/matriculacion']);
    } else if (row.tipo.toLowerCase().includes('cambio') || row.tipo.toLowerCase().includes('noti')) {
      this.router.navigate(['page/cambio']);
    } else if (row.tipo.toLowerCase().includes('distintivo')) {
      this.router.navigate(['page/distintivo']);
    } else if (row.tipo.toLowerCase().includes('justificante')) {
      this.expService.getSolicitud(row.id.toString()).subscribe((res) => {
        console.log(res);
      });
      this.router.navigate(['page/justificante']);
    } else if (row.tipo.toLowerCase().includes('informe')) {
      this.router.navigate(['page/informe']);
    } else if (row.tipo.toLowerCase().includes('reduccion')) {
      this.router.navigate(['page/reduccion']);
    }
  }

  resetAll(): void {
    this.searchForm.reset();
    this.applyFilter();
    this.getServerData();
  }

  listadoFirmasPendientes(): void {
    this.dialog.open(CheckSigafirmaComponent, {
      data: { tipo: 'listado', id: this.colaboradores, estado: 'pendiente' },
    });
    console.log(this.colaboradores);
  }

  listadoFirmasOK(): void {
    this.dialog.open(CheckSigafirmaComponent, {
      data: { tipo: 'listado', id: this.colaboradores, estado: 'firmada' },
    });
    console.log(this.colaboradores);
  }

  goSolicitudes(numExp): void {
    this.router.navigate(['/page/expedientes'], { state: { numExp } });
  }

  print(event: Sort): void {
    console.log(event);
  }

  openDialog(elemento): void {
    const dialogRef = this.dialog.open(UploadFilesComponent, {
      width: '900px',
      maxWidth: '95vw',
      data: {
        id: elemento.id,
        solictud: true,
      },
    });
  }
  openDialogUpdateSolicitud(elemento): void {
    const dialogRef = this.dialog.open(UpdateSolicitudModalComponent, {
      data: {
        id: elemento.id,
        solictud: true,
      },
    });
  }

  enviar(elemento): void {
    const ref = this.dialog.open(EmailModalComponent);
    ref.afterClosed().subscribe((result) => {
      if (result === true) {
        console.log('EMAIL', elemento.email);
        this.expService
          .sendFilesEmailCliente(
            elemento.id,
            elemento.nombre,
            true,
            elemento.email
          )
          .subscribe(
            (res) => {
              console.log(res);
              Swal.fire('', 'Email enviado con éxito', 'success');
            },
            (error) => {
              Swal.fire('', error.error.message, 'warning');
            }
          );
      }
    });
  }

  abrirModalComprobacionSigafirma(elemento): void {
    this.dialog.open(CheckSigafirmaComponent, {
      data: { tipo: 'solicitud', id: elemento.id },
    });
  }
  getServerData(event?: PageEvent): any {
    console.log(event);
    this.spinner = true;
    this.expService
      .getSolicitudes(this.colaboradores, this.filtro, event?.pageIndex + 1)
      .subscribe((res) => {
        this.solicitudes.data = res.items;
        this.updateGroupedSolicitudes();
        console.log(res);
        this.lenghtPagination = res.count;
        this.pageIndex = res.page - 1;
        this.pageSize = res.size;
        this.spinner = false;
        return event;
      });
  }

  /*ORIGINAL:

  cancelar(element): void {
    const ref = this.dialog.open(CancelarPedidoComponent);
    ref.afterClosed().subscribe( result => {
      if (result === true){
        const data = {
          tipo:  'CANCELACION DE UN PEDIDO',
          numPedido: element.numPedido,
          colaborador: element.colaborador,
          email: element.usuarioweb

        };
        this.formData = new FormData();
        Object.keys(data).forEach(key => {
          if (data[key] !== null && data[key] !== undefined) {
            this.formData.append(key, data[key]);
          }
        });
        this.pageService.add_file(this.formData).subscribe((res) => {
          console.log(res);
          Swal.fire('', 'Pedido cancelado con éxito', 'success');
        }, (error) => {
          console.log(error);
          Swal.fire('', '¡Error, no se ha podido realizar la cancelación! ', 'warning');
        });
      }
    });
  }*/
  cancelar(element): void {
    const ref = this.dialog.open(CancelarPedidoComponent);
    ref.afterClosed().subscribe((result) => {
      if (result === true) {
        const data = {
          tipo: 'CANCELACION DE UN PEDIDO',
          numPedido: element.id,
          colaborador: element.colaborador,
          email: element.usuarioweb,
          observaciones: 'Num.Pedido:' + element.numPedido,
        };
        this.formData = new FormData();
        Object.keys(data).forEach((key) => {
          if (data[key] !== null && data[key] !== undefined) {
            this.formData.append(key, data[key]);
          }
        });
        this.pageService.add_file(this.formData).subscribe(
          (res) => {
            console.log(res);
            Swal.fire('', 'Pedido cancelado con éxito', 'success');
            this.applyFilter();
          },
          (error) => {
            console.log(error);
            Swal.fire(
              '',
              error.error,
              'warning'
            );
          }
        );
      }
    });
  }

  cancelarFirma(element): void {
    const ref = this.dialog.open(CancelarFirmaComponent);
    ref.afterClosed().subscribe((result) => {
      if (result === true) {
        this.expService.cancelarProcesoFirma(element.id).subscribe(
          (res) => {
            console.log(res);
            Swal.fire('', 'Firma cancelada con éxito', 'success');
          },
          (error) => {
            Swal.fire('', 'Error al cancelar la firma', 'warning');
          }
        );
      }
    });
  }

  cancelarFirmaDocumento(element): void {
    const ref = this.dialog.open(CancelarFirmaComponent);
    ref.afterClosed().subscribe((result) => {
      if (result === true) {
        this.expService.cancelarProcesoFirma(element.id).subscribe(
          (res) => {
            console.log(res);
            Swal.fire('', 'Firma cancelada con éxito', 'success');
          },
          (error) => {
            Swal.fire('', 'Error al cancelar la firma', 'warning');
          }
        );
      }
    });
  }

  ampliarFirma(element): void {
    this.expService.ampliarProcesoFirma(element.id).subscribe(
      (res) => {
        console.log(res);
        Swal.fire('', 'Plazo de firma ampliado una semana', 'success');
      },
      (error) => {
        Swal.fire('', 'Error al ampliar la firma', 'warning');
      }
    );
  }

  reenviarFirmaSet(element): void {
    this.expService.reenviarFirmaSet(element.id).subscribe(
      (res) => {
        console.log(res);
        Swal.fire('', 'Aviso de firma reenviado', 'success');
      },
      (error) => {
        Swal.fire('', 'Error al reenviar la firma', 'warning');
      }
    );
  }

  reenviarFormularioMoves(element): void {
    this.expService.reenviarFormularioMoves(element.id).subscribe(
      (res) => {
        console.log(res);
        Swal.fire('', 'Formulario reenviado a cliente', 'success');
      },
      (error) => {
        Swal.fire('', 'Error al reenviar el formulario MOVES', 'warning');
      }
    );
  }

  checkButton(element: any): boolean {
    if (element.tipo) {
      if (
        element.tipo.toLowerCase().includes('baja') ||
        element.tipo.toLowerCase().includes('doble')
      ) {
        return false;
      }
      return true;
    }
    return false;
  }

  sendViafirma(solicitiud): void {
    this.dialog.open(SolicitudesFirmaModalComponent, { data: solicitiud });
  }

  deriveStatus(element: any): string {
    if (element.generadoExpediente != null && element.generadoExpediente !== false && element.generadoExpediente !== '0') {
      return 'EXPEDIENTE GENERADO';
    }
    if (element.generadoExpediente === '0') {
      return 'CANCELADA';
    }
    if (element.completada == 1) {
      return 'FORMULARIO COMPLETADO';
    }
    if ((element.completada == null || element.completada == 0)
        && (element.tipo === 'AYUDA MOVES' || element.tipo === 'AYUDA REINICIA')) {
      return 'PENDIENTE FORMULARIO CLIENTE';
    }
    return 'PENDIENTE';
  }

  updateGroupedSolicitudes(): void {
    const data: any[] = this.solicitudes?.data || [];
    const grouped: { [key: string]: any[] } = {};
    for (const col of this.kanbanColumns) {
      grouped[col.key] = [];
    }
    for (const item of data) {
      const status = this.deriveStatus(item);
      (grouped[status] || grouped.PENDIENTE).push(item);
    }
    this.groupedSolicitudes = this.kanbanColumns.map(col => ({
      ...col, items: grouped[col.key]
    }));
  }

  toggleCard(id: number): void {
    if (this.expandedCards.has(id)) {
      this.expandedCards.delete(id);
    } else {
      this.expandedCards.add(id);
    }
  }

  isCardExpanded(id: number): boolean {
    return this.expandedCards.has(id);
  }

  getCardTooltip(item: any): string {
    const lines = [];
    const add = (label: string, value: any) => {
      if (value != null && value !== '') { lines.push(label + ': ' + value); }
    };
    const addDate = (label: string, value: any) => {
      if (value) { lines.push(label + ': ' + new Date(value).toLocaleDateString('es-ES')); }
    };
    const joinParts = (...parts: any[]) => parts.filter(p => p != null && p !== '').join(' ');

    // Trámite
    add('ID', item.id);
    add('Num.Pedido', item.numPedido);
    add('Tipo', item.tipo);
    add('Tipo Trámite', item.tipoTramite);
    add('Colaborador', item.colaborador);
    add('Exp. Ayudas', item.expedienteAyudas);
    addDate('Fecha', item.fecha);

    // Cliente
    add('NIF', item.nif);
    const nombreCompleto = joinParts(item.nombre, item.apellido1, item.apellido2);
    add('Cliente', nombreCompleto);
    add('Email', item.email);
    add('Teléfono', item.telefono);
    const direccion = joinParts(item.direccion, item.direccionnumero, item.direccionEscalera, item.direccionpiso, item.direccionpuerta);
    add('Dirección', direccion);
    const ubicacion = joinParts(item.cp, item.poblacion, item.provincia);
    add('Ubicación', ubicacion);

    // Vehículo
    add('Matrícula', item.matricula);
    add('Bastidor', item.bastidor);
    add('Tipo Vehículo', item.tipoVehiculo);
    add('Marca', item.marca);
    add('Modelo', item.modelo);
    add('Cilindrada', item.cilindrada);
    addDate('F.Matriculación', item.fechaMatriculacion);

    // Vendedor
    add('NIF Vendedor', item.nifVendedor);
    const vendedor = joinParts(item.nombreVendedor, item.apellido1Vendedor, item.apellido2Vendedor);
    add('Vendedor', vendedor);
    add('Email Vendedor', item.emailVendedor);
    add('Tel. Vendedor', item.telefonoVendedor);

    // Estado
    if (item.generadoExpediente && item.generadoExpediente !== '0') {
      add('Expediente', item.generadoExpediente);
    }

    // Observaciones
    if (item.observaciones) {
      const obs = item.observaciones.length > 100 ? item.observaciones.substring(0, 100) + '...' : item.observaciones;
      add('Observaciones', obs);
    }

    return lines.join('\n');
  }

  checkButtonViafirmaSend(element: any): boolean {
    if (element.tipo) {
      if (
        element.tipo.startsWith('MATRICU') ||
        element.tipo.startsWith('CAMBIO') ||
        element.tipo.startsWith('NOTIF')
      ) {
        return true;
      }
    }
    return false;
  }

  /*mostrar(id: any): void{
    let detail_rows = document.querySelectorAll(".detail-row");

    for(let i = 0; i < detail_rows.length; i++) {
      detail_rows[i].setAttribute("style","display:none;"); 
    }
    
    console.log("Mostrando elemento con id:" + id);
    var x = document.getElementById(id);
    this.cargarDocumentos(id);
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  }*/

  mostrar(id: any) {
    var detail_rows = document.querySelectorAll('.detail-row');

    console.log('Mostrando elemento con id: ' + id);
    var x = document.getElementById(id);
    var isVisible = x.style.display !== 'none';

    detail_rows.forEach(function (row) {
      (row as HTMLElement).style.display = 'none';
    });

    if (!isVisible) {
      x.style.display = 'block';
    } else {
      x.style.display = 'none';
    }
    this.cargarDocumentos(id);
  }

  cargarDocumentos(id: any): void {
    console.log('Cargando documentos para la solicitud:' + id);

    this.expService.getDocumentosSolicitud(id).subscribe((res) => {
      console.log(res);
      if (res) {
        this.docList = res;
      }
    });
  }

  verArchivo(doc): void {
    this.expService.getDocumentoss(doc.id).subscribe((response) => {
      const file = new Blob([response]);
      const a = FileSaver.saveAs(file, doc.file.name);
    });
  }
}
